export default __webpack_public_path__ + "static/media/TXT.909b57f7.png";